import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SchoolForm } from 'features/schools/SchoolForm';
import type { SchoolListItem } from 'features/schools/queries';
import { useSchoolId } from 'hooks/useSchoolId';
import { axiosClient } from 'hooks/utils';
import { schoolsActions } from 'store/actions/actions';
import { TabLoader } from './TabLoader';
import { TabErrorAlert } from './TabErrorAlert';

const CollegeEdit = () => {
  const schoolId = useSchoolId();
  const router = useHistory();
  const dispatch = useDispatch();
  const { data: school, error } = useQuery<SchoolListItem, Error>({
    queryKey: ['schoolDetails', schoolId],
    queryFn: async () => {
      const { data } = await axiosClient.get<SchoolListItem>(
        `v2/schools/${schoolId}`,
        { params: { for_dashboard: true } },
      );
      return data;
    },
  });

  if (error) return <TabErrorAlert error={error} />;
  if (!school) return <TabLoader />;

  return (
    <SchoolForm
      inline
      schoolToEdit={school}
      modalProps={{
        opened: true,
        onClose: () => {
          dispatch(schoolsActions.getSchoolById(schoolId));
          router.push(`/schools/${schoolId}/users`);
        },
      }}
    />
  );
};

export default CollegeEdit;
